import apiClient from '../client'
import type { PageResponse } from '../types'
import type {
  BankTransferQueryParams,
  BankTransferQueryRowResponse,
  CsvExportQueryParams,
  CsvExportQueryRowResponse,
  NotificationQueryParams,
  NotificationQueryRowResponse,
} from './types'

export const queriesApi = {
  csvExport(params?: CsvExportQueryParams) {
    return apiClient.get<PageResponse<CsvExportQueryRowResponse>>('/api/queries/csv-export', { params })
  },

  bankTransfer(params?: BankTransferQueryParams) {
    return apiClient.get<PageResponse<BankTransferQueryRowResponse>>('/api/queries/bank-transfer', { params })
  },

  notification(params?: NotificationQueryParams) {
    return apiClient.get<PageResponse<NotificationQueryRowResponse>>('/api/queries/notification', { params })
  },
}
